import { type RouteObject } from 'react-router-dom';

import { ROUTES_PATH } from '@/constants/routes.constants';

export const DrinkRoutes: RouteObject[] = [
  // {
  //   path: ROUTES_PATH.drinkManagement,
  //   children: [
  //     { index: true, lazy: () => import('./drink-list') },
  //     { path: ':id', lazy: () => import('./drink-detail') },
  //     { path: 'new', lazy: () => import('./drink-new') },
  //   ],
  // },
  {
    path: ROUTES_PATH.shopDrinkList,
    children: [
      { index: true, lazy: () => import('./shop-drink-list') },
      { path: ':id', lazy: () => import('./shop-drink-detail') },
    ],
  },
];
